import Styles from "./NSLabelErrorNotifier.module.css";
import { IBaseComponentProps } from "../props/IBaseComponentProps";
import { useRef } from "react";
import { SetTimeouService } from "namirasoft-core";

export interface NSLabelErrorNotifierProps extends IBaseComponentProps
{
	error?: string;
	clearError: () => void;
}

export function NSLabelErrorNotifier(props: NSLabelErrorNotifierProps)
{
	let service = useRef<SetTimeouService>(new SetTimeouService());
	if (props.error)
		service.current.setTimeoutIfNotCalledAgain(() =>
		{
			props.clearError();
		}, 5000);
	return <>
		{
			props.error && (
				<div id={props.id} className="d-flex justify-content-start align-items-center gap-2 ms-2">
					<img
						className={""}
						src="https://static.namirasoft.com/image/concept/danger/red.svg"
						alt="Error Icon"
						width={13}
						height={13}
					/>
					<span className={Styles.ns_label_error_notifier_text}>{props.error}</span>
				</div >
			)
		}
	</>;
}